<template>
  <div id="addShareRecipientContainer" :class="['form-group', {'has-error': hasFieldErrors('dataForm.recipients')}]">
    <div v-if="hasFieldErrors('dataForm.recipients')">
      <span v-for="error in getFieldErrors('dataForm.recipients')" class="help-block" :key="error">{{ error }}</span>
    </div>
    <label v-else for="recipients" class="sr-only">
      <span class="required">*</span> {{ pDictionary['dictionary.share.recipient.plural'] }}
    </label>
    <input ref="addShareRecipientInputText" id="recipients" type="text" class="selectize"
           autocomplete="off" :data-noresults-text="pDictionary['dictionary.share.recipient.search.none']"
           :placeholder="pDictionary['dictionary.share.recipient.search.placeholder']"/>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import refhelpers from "@/helpers/ref-helpers";

export default {
  name: "ShareSaveFormRecipientAdd",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pProjectId: Number
  },
  data: function () {
    return {
      recipient: null
    }
  },
  methods: {
    onAddShareRecipient: function () {
      let _component = this;
      _component.$emit('share-recipient-added', this.recipient);
      _component.recipient = null;

      let $addShareRecipientInputText = $(_component.$refs.addShareRecipientInputText);
      $addShareRecipientInputText[0].selectize.clear(true);
      $addShareRecipientInputText[0].selectize.clearOptions();
    }
  },
  computed: {
    isAddShareRecipientDisabled: function () {
      return this.recipient === null;
    }
  },
  mounted: function () {
    let _component = this;
    let $addShareRecipientInputText = $(_component.$refs.addShareRecipientInputText);

    var REGEX_EMAIL = '\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+';

    $addShareRecipientInputText.selectize({
                                            dropdownParent: 'body',
                                            inputClass: 'form-control selectize-input dropdown-menu-position-inline',
                                            openOnFocus: false,
                                            selectOnTab: true,
                                            closeAfterSelect: true,
                                            addPrecedence: true,
                                            persist: false,
                                            maxItems: '1',
                                            valueField: 'email',
                                            labelField: 'name',
                                            searchField: ['name', 'email'],
                                            load: function (query, callback) {
                                              if(!query.length)
                                              {
                                                return callback();
                                              }
                                              $.ajax({
                                                       url: '/mediaplan/app/endpoints/json-api/share/recipients/addable',
                                                       type: 'GET',
                                                       data: {
                                                         'projectId': _component.pProjectId || 0,
                                                         'q': query
                                                       },
                                                       headers: {
                                                         'Accept': 'application/json',
                                                         'Content-Type': 'application/json'
                                                       },
                                                       error: function () {
                                                         callback();
                                                       },
                                                       success: function (res) {
                                                         callback(res);
                                                       }
                                                     });
                                            },
                                            render: {
                                              item: function (item, escape) {
                                                _component.recipient = item;

                                                if(item.name)
                                                {
                                                  return '<div>' +
                                                         '<span class="name">' + escape(item.name) + '</span>' +
                                                         '<span class="email with-name">' + escape(item.email) + '</span>' +
                                                         '</div>';
                                                }
                                                else
                                                {
                                                  return '<div>' +
                                                         '<span class="email">' + escape(item.email) + '</span>' +
                                                         '</div>';
                                                }
                                              },
                                              option: function (item, escape) {
                                                let parentNameLine = '';
                                                if(refhelpers.isValidRef(item.contactRef)
                                                   && !$.isEmptyObject(item.contactRef.params)
                                                   && 'parentName' in item.contactRef.params
                                                   && item.contactRef.params.parentName !== undefined)
                                                {
                                                  parentNameLine = item.contactRef.params.parentName + '<br/>'
                                                }
                                                return '<address class="bs3-margin-bottom5">' +
                                                       '<strong>' + escape(item.name) + '</strong><br/>' +
                                                       parentNameLine +
                                                       escape(item.email) +
                                                       '</address>'
                                              }
                                            },
                                            createFilter: function (input) {
                                              var match, regex;

                                              // email@address.com
                                              regex = new RegExp('^' + REGEX_EMAIL + '$', 'i');
                                              match = input.match(regex);
                                              if(match)
                                              {
                                                return !Object.prototype.hasOwnProperty.call(this.options, match[0]);
                                              }

                                              // name <email@address.com>
                                              regex = new RegExp('^([^<]*)<' + REGEX_EMAIL + '>$', 'i');
                                              match = input.match(regex);
                                              if(match)
                                              {
                                                return !Object.prototype.hasOwnProperty.call(this.options, match[2]);
                                              }

                                              return false;
                                            },
                                            create: function (input) {
                                              if((new RegExp('^' + REGEX_EMAIL + '$', 'i')).test(input))
                                              {
                                                return {email: input};
                                              }
                                              var match = input.match(new RegExp('^([^<]*)<' + REGEX_EMAIL + '>$', 'i'));
                                              if(match)
                                              {
                                                return {
                                                  email: match[2],
                                                  name: $.trim(match[1])
                                                };
                                              }
                                              return false;
                                            },
                                            onItemAdd: function(value, $item) {
                                              _component.onAddShareRecipient();
                                            },
                                            onItemRemove: function (value) {
                                              _component.recipient = null;
                                            },
                                            onInitialize: function() {
                                              _component.$nextTick(function() {
                                                $addShareRecipientInputText[0].selectize.focus();
                                              });
                                            }
                                          });


  },
  destroy: function () {

  }
}
</script>

<style scoped>

</style>